/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */
 
 <template>
    <div class="paso-cinco-container">
        <div class="confirmation-header">
            <h2>Nuevo Proyecto <strong>{{ formData.codigoProyecto || 'aom-001-1' }}</strong></h2>
            <span>{{ formData.nombreProyecto }}</span>
        </div>
        <div class="confirmation-content">
            <div class="confirmation-main-grid">
                <div class="grid-col">
                    <div class="info-card">
                        <h4>Información del contacto</h4>
                        <div class="info-item"><label>Código del proyecto:</label><span>{{ formData.codigoProyecto ||
                            'aom-001' }}</span></div>
                        <div class="info-item"><label>Contacto:</label><span>{{ formData.nombre }} {{
                            formData.apellidoPaterno
                                }}</span></div>
                        <div class="info-item"><label>Localidad:</label><span>{{ formData.localidadProyecto }}</span>
                        </div>
                        <div class="info-item"><label>Tipo:</label><span>Recomendación</span></div>
                        <div class="info-item"><label>Teléfono:</label><span>{{ formData.telefono }}</span></div>
                        <div class="info-item"><label>Correo electrónico:</label><span>{{ formData.email }}</span></div>
                    </div>
                    <div class="savings-card">
                        <h4>Sin paneles</h4>
                        <div class="savings-item"><label>Pago mensual promedio a CFE</label><span>{{ (totalPagoHistorico
                            / 3).toLocaleString('es-MX', {
                                style: 'currency', currency: 'MXN',
                                minimumFractionDigits: 2
                            }) || '$109,264.55' }}</span></div>
                    </div>
                    <div class="info-card environmental-benefit-card">
                        <h4>Beneficio ambiental anual</h4>
                        <div class="environmental-item"><i class="icon-cloud"></i> <span>{{
                            environmentalBenefit.co2Reduced ? environmentalBenefit.co2Reduced.toLocaleString() :
                                '32,000' }} kgCO2 sin emitir</span></div>
                        <div class="environmental-item"><i class="icon-tree"></i> <span>{{
                            environmentalBenefit.treesPlanted ? environmentalBenefit.treesPlanted.toLocaleString() :
                                '50' }} árboles plantados</span></div>
                        <div class="environmental-item"><i class="icon-car"></i> <span>{{
                            environmentalBenefit.kmNotDriven ?
                                environmentalBenefit.kmNotDriven.toLocaleString('es-MX', { maximumFractionDigits: 2 }) :
                                '15,000.55' }} km sin manejar
                                auto</span></div>
                    </div>
                    <div class="info-card tir-card">
                        <h4>TIR a 25 años</h4>
                        <label>Tasa interna de retorno a 25 años</label>
                        <span>{{ tirRoi.tir ? tirRoi.tir.toFixed(2) : '25.42' }}%</span>
                    </div>
                </div>
                <div class="grid-col">
                    <div class="info-card">
                        <h4>Información del consumo</h4>
                        <div class="info-item"><label>Nombre:</label><span>{{ formData.nombreProyecto }}</span></div>
                        <div class="info-item"><label>Tarifa:</label><span>{{ formData.tarifaCFE }}</span></div>
                        <div class="info-item"><label>División:</label><span>Jalisco</span></div>
                        <div class="info-item"><label>Número de servicio:</label><span>{{ formData.numeroServicio
                                }}</span></div>
                        <div class="info-item"><label>KWh/mes:</label><span>{{ (totalKwhHistorico /
                            6).toLocaleString('es-MX', { maximumFractionDigits: 2 }) || '36602.58' }}</span></div>
                        <div class="info-item"><label>Monto mensual:</label><span>{{ (totalPagoHistorico /
                            3).toLocaleString('es-MX', {
                                style: 'currency', currency: 'MXN', minimumFractionDigits:
                                    2
                            }) || '$109,264.55' }}</span></div>
                    </div>
                    <div class="savings-card">
                        <h4>Con paneles</h4>
                        <div class="savings-item-inline">
                            <div class="savings-item"><label>Pago mensual promedio a CFE</label><span>{{
                                roiDetail.length > 0 ? (roiDetail.reduce((acc, item) => acc + item.nuevoPago, 0) /
                                    3).toLocaleString('es-MX', {
                                        style: 'currency', currency: 'MXN',
                                        minimumFractionDigits: 2
                                    }) : '$74,972.05'}}</span></div>
                            <div class="savings-item"><label>Ahorro mensual</label><span class="text-green">{{
                                roiDetail.length > 0 ? ((totalPagoHistorico / 3) - (roiDetail.reduce((acc, item) =>
                                    acc + item.nuevoPago, 0) / 3)).toLocaleString('es-MX', {
                                        style: 'currency',
                                        currency: 'MXN', minimumFractionDigits: 2
                                    }) : '$34,292.50'}}</span></div>
                        </div>
                    </div>
                    <div class="info-card total-cost-card">
                        <h4>Gasto total a 25 años</h4>
                        <div class="total-cost-grid">
                            <div><label>Sin paneles</label><span>{{
                                totalCost25Years.withoutPanels.toLocaleString('es-MX', {
                                    style:
                                        'currency', currency: 'MXN'
                                }) }}</span></div>
                            <div><label>Con paneles</label><span>{{ totalCost25Years.withPanels.toLocaleString('es-MX',
                                {
                                    style:
                                        'currency', currency: 'MXN'
                                }) }}</span></div>
                            <div><label>Ahorro</label><span class="text-green">{{
                                totalCost25Years.savings.toLocaleString('es-MX', {
                                    style: 'currency', currency: 'MXN'
                                }) }}</span></div>
                        </div>
                    </div>
                    <div class="info-card roi-card">
                        <h4>ROI Flujos acumulados</h4>
                        <label>Recuperación de inversión</label>
                        <span>{{ tirRoi.roiYears }} años {{ tirRoi.roiMonths }} meses</span>
                    </div>
                </div>
            </div>
            <div class="info-card historical-consumption-card">
                <h4>Consumo histórico</h4>
                <div class="consumption-table-wrapper">
                    <div class="consumption-table-grid">
                        <div class="consumption-table-row header">
                            <span>Inicio</span><span>Término</span><span class="text-right">kW Punta</span><span
                                class="text-right">kWh Totales</span><span class="text-right">Pago a CFE</span>
                        </div>
                        <div class="consumption-table-row" v-for="(item, index) in consumoHistorico" :key="index">
                            <span>{{ item.inicio }}</span><span>{{ item.termino }}</span><span class="text-right">{{
                                item.kwPunta.toFixed(1) }}</span><span class="text-right">{{
                                    item.kwhTotales.toLocaleString()
                                }}</span><span class="text-right">{{ item.pago.toLocaleString('es-MX', {
                                    style: 'currency', currency:
                                        'MXN'
                                }) }}</span>
                        </div>
                        <div class="consumption-table-row footer">
                            <span></span><span>Total</span><span></span><span class="text-right">{{
                                totalKwhHistorico.toLocaleString()
                                }}</span><span class="text-right">{{ totalPagoHistorico.toLocaleString('es-MX', {
                                    style: 'currency',
                                    currency: 'MXN'
                                }) }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="info-card roi-detail-card">
                <h4>Detalle del retorno de inversión</h4>
                <div class="roi-detail-table-wrapper">
                    <div class="roi-detail-table">
                        <div class="roi-detail-row header">
                            <span>Periodo</span><span>Consumo histórico</span><span>Energía generada</span><span>Nuevo
                                pago a
                                CFE</span><span>Pago histórico</span><span>Ahorro por periodo</span>
                        </div>
                        <div class="roi-detail-row" v-for="(item, index) in roiDetail" :key="index">
                            <span>{{ item.periodo }}</span><span>{{ item.consumo.toLocaleString() }} kWh</span><span>{{
                                item.generada.toLocaleString() }} kWh</span><span>{{
                                    item.nuevoPago.toLocaleString('es-MX', {
                                        style:
                                            'currency', currency: 'MXN'
                                    }) }}</span><span>{{ item.pagoHistorico.toLocaleString('es-MX', {
                                    style:
                                        'currency', currency: 'MXN'
                                }) }}</span><span>{{ item.ahorro.toLocaleString('es-MX', {
                                    style:
                                        'currency', currency: 'MXN'
                                }) }}</span>
                        </div>
                        <div class="roi-detail-row footer">
                            <span class="col-span-5">Ahorro anual</span>
                            <span>{{roiDetail.reduce((acc, item) => acc + item.ahorro, 0).toLocaleString('es-MX', {
                                style: 'currency',
                                currency: 'MXN'
                            })}}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="project-actions-grid">
                <div class="action-card">
                    <h4>Proyecto</h4>
                    <div class="action-section"><label>Borrador</label>
                        <p>Puedes guardar un borrador y terminarlo después.</p>
                        <button type="button" class="btn-secondary pill btn-full-mobile">Guardar como borrador</button>
                    </div>
                    <div class="action-section"><label>Tarea</label>
                        <p>Asigna una tarea al proyecto y así no olvidarás tus pendientes.</p>
                        <button type="button" class="btn-secondary pill btn-full-mobile">Agregar Tarea</button>
                    </div>
                </div>
                <div class="action-card">
                    <h4>Descargar documentos</h4>
                    <div class="document-links"><a href="#">Actualizar Suministrador</a><a href="#">Generar
                            Contrato</a><a href="#">Obtener carta poder</a><a href="#">Descargar ficha técnica del
                            panel</a></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {

    props: {
        formData: { type: Object, required: true },
        consumoHistorico: { type: Array, required: true },
        environmentalBenefit: { type: Object, required: true },
        totalCost25Years: { type: Object, required: true },
        tirRoi: { type: Object, required: true },
        quoteReview: { type: Array, required: true },
        totalKwhHistorico: { type: Number, required: true },
        totalPagoHistorico: { type: Number, required: true },
        accumulatedExpenseChartData: { type: Object, required: true },
        annualConsumptionChartData: { type: Object, required: true },
        chartDataLoaded: { type: Boolean, required: true },
        roiDetail: { type: Array, required: true },
    },
};
</script>

<style scoped>

.confirmation-header {
    margin-bottom: 25px;
}

.confirmation-header h2 {
    font-size: 24px;
    color: var(--color-texto-principal, #333);
    font-weight: 400;
}

.confirmation-header strong {
    font-weight: 700;
    color: #29b9f6;
}

.confirmation-header span {
    color: var(--color-texto-secundario, #666);
    font-size: 16px;
}

.confirmation-content {
    display: flex;
    flex-direction: column;
    gap: 25px;
}

.confirmation-main-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 25px;
    align-items: start;
}

.grid-col {
    display: flex;
    flex-direction: column;
    gap: 25px;
}

.info-card {
    background-color: var(--color-fondo-claro, #f8f9fa);
    border-radius: 12px;
    padding: 25px;
    border: 1px solid var(--color-borde, #e2e8f0);
}

.info-card h4 {
    font-size: 16px;
    font-weight: 600;
    color: var(--color-texto-principal, #333);
    margin: 0 0 20px 0;
    padding-bottom: 15px;
    border-bottom: 1px solid #e2e8f0;
}

.company-info {
    display: flex;
    gap: 30px;
    align-items: start;
}

.logo-placeholder {
    width: 80px;
    height: 80px;
    background-color: #e2eeef;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    color: #4a5568;
    flex-shrink: 0;
}

.company-details,
.company-description {
    flex-grow: 1;
}

.company-details p,
.company-description p {
    margin: 0 0 10px 0;
    font-weight: 500;
}

.company-details span {
    display: block;
    margin-bottom: 8px;
    font-size: 14px;
    color: #4a5568;
}

.info-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    padding: 10px 0;
    border-bottom: 1px solid #e2e8f0;
}

.info-item:last-child {
    border-bottom: none;
}

.info-item label {
    color: #718096;
    font-weight: 500;
}

.info-item span {
    color: var(--color-texto-principal, #333);
    font-weight: 500;
}

.savings-card {
    background-color: var(--color-fondo-claro, #f8f9fa);
    border-radius: 12px;
    padding: 25px;
    border: 1px solid var(--color-borde, #e2e8f0);
}

.savings-item label {
    display: block;
    font-size: 12px;
    color: #718096;
    margin-bottom: 5px;
}

.savings-item span {
    font-size: 22px;
    font-weight: 600;
    color: var(--color-texto-principal, #333);
}

.savings-item-inline {
    display: flex;
    gap: 30px;
}

.text-green {
    color: var(--color-exito, #10b981);
}

.total-cost-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    text-align: center;
}

.total-cost-grid div {
    display: flex;
    flex-direction: column;
    padding: 15px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    background-color: #fff;
}

.total-cost-grid label {
    font-size: 12px;
    color: #718096;
    margin-bottom: 5px;
}

.total-cost-grid span {
    font-size: 18px;
    font-weight: 600;
    color: var(--color-texto-principal, #333);
}

.tir-card,
.roi-card {
    text-align: center;
}

.tir-card label,
.roi-card label {
    display: block;
    font-size: 12px;
    color: #718096;
    margin-top: 5px;
}

.tir-card span,
.roi-card span {
    font-size: 28px;
    font-weight: 700;
    color: var(--color-texto-principal, #333);
    display: block;
    margin-top: 10px;
}

.environmental-item {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #4a5568;
}

.environmental-item i {
    font-size: 18px;
    margin-right: 10px;
    color: var(--color-primario, #29b9f6);
    width: 24px;
    text-align: center;
}

.icon-cloud::before {
    content: "☁";
}

.icon-tree::before {
    content: "🌳";
}

.icon-car::before {
    content: "🚗";
}

.consumption-table-wrapper {
    overflow-x: auto;
}

.consumption-table-grid {
    min-width: 650px;
    font-size: 14px;
    color: #4a5568;
}

.consumption-table-row {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 15px;
    padding: 12px 0;
    border-bottom: 1px solid #e9eef2;
}

.consumption-table-row.header {
    font-weight: 600;
    color: #718096;
}

.consumption-table-row.footer {
    font-weight: bold;
    color: var(--color-texto-principal, #333);
    border-top: 1px solid #e2e8f0;
    margin-top: 8px;
    padding-top: 12px;
}

.text-right {
    text-align: right;
}

.roi-detail-table-wrapper {
    overflow-x: auto;
}

.roi-detail-table {
    min-width: 1000px;
    font-size: 13px;
    text-align: right;
}

.roi-detail-row {
    display: grid;
    grid-template-columns: 1.5fr 1fr 1fr 1fr 1fr 1fr;
    gap: 15px;
    padding: 10px 0;
    border-bottom: 1px solid #e9eef2;
}

.roi-detail-row span:first-child {
    text-align: left;
}

.roi-detail-row.header {
    font-weight: 600;
    color: #718096;
}

.roi-detail-row.footer {
    font-weight: bold;
    color: var(--color-texto-principal, #333);
    border-top: 1px solid #e2e8f0;
    margin-top: 8px;
}

.roi-detail-row.footer .col-span-5 {
    grid-column: span 5;
    text-align: right;
}
.project-actions-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 25px;
}

.action-card {
    background-color: var(--color-fondo-claro, #f8f9fa);
    border-radius: 12px;
    padding: 25px;
    border: 1px solid var(--color-borde, #e2e8f0);
}

.action-card h4 {
    font-size: 16px;
    margin: 0 0 15px 0;
    padding-bottom: 15px;
    border-bottom: 1px solid #e2e8f0;
}

.action-section {
    margin-bottom: 20px;
}

.action-section label {
    font-weight: bold;
    font-size: 14px;
}

.action-section p {
    font-size: 13px;
    color: #718096;
    margin: 5px 0 15px 0;
}

.document-links {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.document-links a {
    color: var(--color-primario, #29b9f6);
    text-decoration: none;
    font-weight: 600;
    font-size: 14px;
}

@media (max-width: 768px) {
    .confirmation-main-grid {
        grid-template-columns: 1fr;
        gap: 20px;
    }

    .savings-item-inline {
        flex-direction: column;
        gap: 15px;
    }

    .total-cost-grid {
        grid-template-columns: 1fr;
        gap: 10px;
    }

    .consumption-table-wrapper,
    .roi-detail-table-wrapper {
        overflow-x: auto;
        border: 1px solid var(--color-borde, #e2e8f0);
        border-radius: 8px;
        padding: 0;
    }

    .consumption-table-grid {
        min-width: 600px;
        font-size: 12px;
        padding: 0 10px;
    }

    .roi-detail-table {
        min-width: 800px;
        font-size: 11px;
    }

    .company-info {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;
    }

    .company-details {
        text-align: center;
    }

    .company-details span {
        text-align: center;
    }

    .company-description {
        width: 100%;
        text-align: center;
        margin-top: 0;
    }

    .project-actions-grid {
        grid-template-columns: 1fr;
        gap: 20px;
    }

    .btn-full-mobile {
        width: 100%;
    }
}
</style>